import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const statusPillVariants = cva(
  "inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium [&_svg]:size-3 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        success: "bg-success/10 text-success",
        warning: "bg-warning/10 text-warning",
        destructive: "bg-destructive/10 text-destructive",
        info: "bg-info/10 text-info",
        neutral: "bg-subtle text-subtle-foreground"
      }
    },
    defaultVariants: { variant: "neutral" }
  }
);

export interface StatusPillProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof statusPillVariants> {
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

const StatusPill = React.forwardRef<HTMLSpanElement, StatusPillProps>(({ className, variant, icon: Icon, children, ...props }, ref) => (
  <span ref={ref} className={cn(statusPillVariants({ variant }), className)} {...props}>
    {Icon ? <Icon aria-hidden="true" /> : null}
    {children}
  </span>
));
StatusPill.displayName = "StatusPill";

export { StatusPill, statusPillVariants };
